import type { ComponentPropsWithRef } from "react";

import { cn } from "@/lib/utils";

type ProductListHeaderProps = ComponentPropsWithRef<"header">;

const ProductListHeader = ({
  className,
  children,
  ...props
}: ProductListHeaderProps) => {
  if (!children) return null;

  return (
    <header
      className={cn(
        "mt-4 flex items-start justify-between gap-4 px-4 pb-4 text-lg tracking-wide",
        className,
      )}
      {...props}
    >
      {children}
    </header>
  );
};

ProductListHeader.displayName = "ProductListHeader";

export default ProductListHeader;
